<template>
  <div>
    <div :class="modalClass" class="modal">
      <header v-if="showHeader" class="modal__header">
        <h3 class="heading -medium">
          {{ heading }}
        </h3>
        <p v-if="subheading">
          {{ subheading }}
        </p>
        <button class="close-modal" @click.prevent="handleCloseClick">
          <span class="iconfont-menu-close" />
        </button>
      </header>

      <div :class="bodyClass">
        <slot />
      </div>

      <footer v-if="showFooter" class="modal__footer">
        <button @click.prevent="handleCloseClick">
          {{ buttonText }}
        </button>
      </footer>
    </div>
    <div class="overlay" @click.prevent="handleCloseClick" />
  </div>
</template>

<script>
/*
 * Modal sub types:
 * calendar - shown scheduling workouts and plans
 * confirm - on scheduled instances of plans, start over on reschedule, notification delete all
 * error - 500 error from ajax api calls
 * flag - on comments and notifications
 * login - shown on comments, trying to favorite or add to calendar
 * custom workout complete - for custom workout "completes" that have user specified minutes
 */
export default {
  inject: ['$validator'], // adds parent validator, this handles the case of forms being in slots
  props: {
    modalClass: {
      default: '',
      type: String,
    },
    // eslint-disable-next-line
    handleCloseClick: Function,
    heading: {
      default: 'Modal Heading',
      type: String,
    },
    subheading: {
      default: null,
      type: String,
    },
    bodyClass: {
      default: 'modal__body',
      type: String,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    showFooter: {
      default: false,
      type: Boolean,
    },
    buttonText: {
      type: String,
      default: 'Close Window',
    },
  },
}
</script>
